import axios from 'axios'
import { toast } from 'react-toastify'

export const getTeams = async (cancelToken) => {
  try {
    const res = await axios.get('teams', { cancelToken })
    if (res.data.success) {
      return { success: true, data: res.data.data }
    }
    return { success: false, data: [] }
  } catch (error) {
    if (!axios.isCancel(error)) {
      console.error('Error fetching teams:', error)
      toast.error(error?.response?.data?.message || 'Error fetching teams')
    }
    return { success: false, data: [], error }
  }
}

export const createTeam = async ({ body }) => {
  try {
    const res = await axios.post('teams', { ...body })
    if (res.data.success) {
      toast.success('Team created successfully')
      return { success: true, data: res.data.data }
    }
    return { success: false }
  } catch (error) {
    toast.error(error?.response?.data?.message || 'Error creating team')
    return { success: false, error }
  }
}

export const updateTeam = async ({ id, body }) => {
  try {
    const res = await axios.put(`teams/updateOne/${id}`, { ...body })
    if (res.data.status || res.data.success) {
      toast.success('Team updated successfully')
      return { success: true, data: res.data.data }
    }
    return { success: false }
  } catch (error) {
    toast.error(error?.response?.data?.message || 'Error updating team')
    return { success: false, error }
  }
}

export const deleteTeam = async ({ id }) => {
  try {
    const res = await axios.put(`teams/delete/${id}`)
    if (res.data.status || res.data.success) {
      toast.success('Team deleted successfully')
      return { success: true }
    }
    return { success: false }
  } catch (error) {
    toast.error(error?.response?.data?.message || 'Error deleting team')
    return { success: false, error }
  }
}